import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
/**
 * `GET /api/library` — read for its `stats` alone.
 *
 * The response is the whole curated landing payload (hero, people, sections,
 * tiles). This screen builds its shelves from the typed content lists instead,
 * because those carry the fields the cards need and the tiles do not — a tile
 * is `{id, type, path, label}` and nothing else.
 *
 * What only this read has is the SIZE of the library: "19+ pieces across 6
 * collections" opens the design's sub-line and is the half that answers "is
 * there enough here for me". So the schema is deliberately narrow and the rest
 * of the payload is allowed through unvalidated — parsing sections we do not
 * render would turn an editor's curation change into a broken screen.
 */
export const LibraryStats = z
    .object({
    stats: z.object({
        publishedItems: z.number().int().nonnegative(),
        collections: z.number().int().nonnegative(),
    }),
})
    .passthrough();
export function useLibraryStats(http, locale) {
    return useQuery({
        queryKey: ['library', 'stats', locale],
        queryFn: () => http.get('/library', { schema: LibraryStats, locale }),
        staleTime: 10 * 60_000,
    });
}
//# sourceMappingURL=library-stats.js.map